import {Fragment, PureComponent} from 'react'
import PropTypes from 'prop-types'

import Video from './Video.jsx'

export default class OurVideosList extends PureComponent {
  static propTypes = {
    videos: PropTypes.array,
    currentPlayingId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    onPlay: PropTypes.func,
    onPause: PropTypes.func,
  }

  static defaultProps = {
    videos: [],
    currentPlayingId: null,
    onPlay: () => {},
    onPause: () => {},
  }

  render() {
    const { videos, currentPlayingId, onPlay, onPause } = this.props

    return (
      <Fragment>
        <div className="our-videos-list mt-5">
          {videos.map(video => video.videoPath ? (
            <Video
              key={video.id}
              videoId={video.id}
              videoPath={video.videoPath}
              videoType={video.videoType}
              posterPath={video.posterPath}
              isPlaying={currentPlayingId === video.id}
              onPlay={onPlay}
              onPause={onPause}
            />
          ) : null )}
        </div>
      </Fragment>
    )
  }
}
